import React from 'react'
import Intro from './Intro'
import Highlights from './Highlights'
import Confidence from './Confidence'
import Model from './Model'
import Roadmap from './Roadmap'
// import Team from './Team'
import TrustBy from './TrustBy'
import './style.scss'

const Home: React.FC = () => {
  return (
    <div id="home" className="container">
      <Intro />
      <Highlights />
      <Confidence />
      <Model />
      <Roadmap />
      <TrustBy />
    </div>
  )
}

export default Home
